<template lang="html">
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">#</th>
        <th scope="col" class="border-0">Nome</th>
        <th scope="col" class="border-0 text-center">N.º Letras</th>
        <th scope="col" class="border-0">Palavra</th>
        <th scope="col" class="border-0">Data publicação</th>
        <th scope="col" class="border-0">Status</th>
        <th scope="col" class="border-0">Opções</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in puzzles" :key="index">
        <td>{{ row.id }}</td>
        <td class="td-4 link">
          <a @click="editPuzzle(row)">{{ row.name }}</a>
        </td>
        <td class="text-center">{{ row.word.length }}</td>
        <td>{{ row.word }}</td>
        <td>{{ row.f_published_date }}</td>
        <td>{{ row.status }}</td>
        <td class="td-2">
          <puzzle-buttons :puzzle="row" @selectedPuzzle="editPuzzle"></puzzle-buttons>
        </td>
      </tr>
      <tr v-if="puzzles.length === 0">
        <td colspan="7" class="no-content">Ainda não tem nenhum jogo cadastrado.</td>
      </tr>
    </tbody>
    <confirmation-modal
      :cancel="close"
      :confirm="deleteRow"
      title="Confirme exclusão de jogo"
      message="Tem certeza que deseja excluir este jogo?"
    />
    <puzzle-form-modal :puzzle="selectedPuzzle"/>
  </table>
</template>

<script>
import Events from '_utils/events';
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import PuzzleButtons from './PuzzleButtons.vue';
import PuzzleDelete from './PuzzleDelete';
import { MODEL, _LOAD_MODEL_, _DELETE_PUZZLE_, _NEW_MODEL_ } from './PuzzleTermModel';
import PuzzleFormModal from '../components/PuzzleFormModal.vue';


export default {
  name: 'puzzle-table',
  mixins: [PuzzleDelete],
  components: {
    PuzzleButtons,
    PuzzleFormModal,
    ConfirmationModal,
  },
  props: {
    puzzles: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedPuzzle: cloneDeep(MODEL),
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
    ]),
    editPuzzle(puzzle) {
      this.selectedPuzzle = puzzle;
      this.selectedPuzzle.letter = puzzle.word.length;
      Events.$emit(_LOAD_MODEL_, this.selectedPuzzle);
      this.setToggle({ type: 'puzzle_form_modal', bool: true });
    },
  },
  destroyed() {
    Events.$off(_DELETE_PUZZLE_);
  },
  mounted() {
    Events.$on(_DELETE_PUZZLE_, puzzle => {
      this.selectPuzzle = puzzle.id;
    });
    Events.$on(_NEW_MODEL_, () => {
      this.editPuzzle(MODEL);
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.link {
  color: $primary;
  a {
    cursor: pointer;
  }
}

.td {
  &-2 {
    width: 280px;
  }
  &-3 {
    min-width: 140px;
  }
  &-4 {
    min-width: 200px;
  }
}
</style>
